// native
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

// service
import { ItemsDisplayService } from '../../../core/services/items-display.service';
import { CitationsQueueService } from '../../../core/services/citations-queue.service';
import { CitationsEventService } from '../../../core/services/citations-event.service';
import { ToastService } from '../../../core/services/toast.service';

@Component({
  selector: 'scs-override-panel',
  templateUrl: './override-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverridePanelComponent implements OnInit {

  form: UntypedFormGroup;
  isLoading: boolean = false;
  isSubmitted: boolean = false;

  constructor(
    public itemsDisplayService: ItemsDisplayService,
    private formBuilder: UntypedFormBuilder,
    private citationsQueueService: CitationsQueueService,
    private citationsEventService: CitationsEventService,
    private toastService: ToastService
  ) { }

  ngOnInit(): void {
    this.initForm();
  }

  onClose() {
    this.citationsQueueService.overridePanelVisible$.next(false);
  }

  onCancel() {
    this.citationsQueueService.overridePanelVisible$.next(false);
  }

  initForm() {
    let overrideText = this.citationsQueueService.citationQueueOptions?.manual_text_override;
    this.form = this.formBuilder.group({
      overrideText: [overrideText, [Validators.required, Validators.maxLength(200)]],
    });
  }

  async onReset() {
    if (!this.citationsQueueService.citationQueueOptions?.manual_text_override) {
      this.toastService.openToast({
        text: `This citation already has it's default value in the document.`,
        type: 'success'
      });
      return;
    }

    this.isLoading = true;

    this.citationsQueueService.citationQueueOptions.manual_text_override = null;

    await this.citationsEventService.addCitation(true, true);

    this.isLoading = false;
    this.citationsQueueService.overridePanelVisible$.next(false);
  }

  onSave() {
    this.isSubmitted = true;
    this.form.markAllAsTouched();

    if (this.form.invalid) {
      return;
    }

    if (!this.citationsQueueService.citationQueueOptions)
      this.citationsQueueService.citationQueueOptions = {};

    this.citationsQueueService.citationQueueOptions.manual_text_override = this.form.controls.overrideText.value;
    this.citationsQueueService.overridePanelVisible$.next(false);
  }
}
